import React, { useEffect, useState } from 'react'
import useSearch from '../../../context/search/useSearch'
import SearchFilter from './Components/SearchFilter'

const SearchFilters: React.FC = (): JSX.Element => {

  const { searchFilters, inputEventHandlers, showClear, productSearchResult } = useSearch()
  const [filteredNumber, setFilteredNumber] = useState(0)
  const [openFilters, setOpenFilters] = useState<number[]>([]);

  useEffect(() => {
    if (productSearchResult && showClear) {
      setFilteredNumber(productSearchResult.records)
    }
  }, [productSearchResult])

  const toggleFilterOpen = (index: number) => {
    setOpenFilters((prevOpenFilters) => {
      if (prevOpenFilters.includes(index)) {
        return [];
      } else {
        return [index];
      }
    });
  };

  return (
    <React.Fragment>
      
      <div className={'sf-search-filters-container'}>
        {!searchFilters
         && <div>
           {/* Loading Filters... */}
         </div>}
        {searchFilters && <React.Fragment>
          {searchFilters.map((filter, index) => {
            if (filter.options.length > 0) {
              return (
                <SearchFilter
                  key={index}
                  index={index}
                  filter={filter}
                  open={openFilters.includes(index)}
                  onToggleOpen={() => toggleFilterOpen(index)}
                />
              );
            }
            return null;
          })}
        </React.Fragment>}
        {showClear && <div className="apply-filters flex space-between align-center margin-t-auto">
          <button className="btn btn--primary" onClick={inputEventHandlers.handleButtonPress} >Apply ({filteredNumber})</button>
          <span role="button" className="cta-basic" onClick={inputEventHandlers.handleClearFilters}>Clear All</span></div>}
      </div>
    </React.Fragment>
  )
}

export default SearchFilters